import { useScrollReveal } from "../../hooks/useScrollReveal";

const items = [
  {
    label: "Testing cycles in days, not weeks",
    body: "Modern paid media demands fast iteration. When a creative stops working or an audience segments, you need a decision the same day. Not a two-week sprint and a status update. We move at the pace the channel requires.",
  },
  {
    label: "Two operators. No layers.",
    body: "Traditional agency math: you pay senior rates, a senior person pitches the account, a junior person runs it. Our math is different. Two operators means every dollar of the retainer goes to the people actually in your account. No account-manager handoff. No forwarded emails.",
  },
  {
    label: "Focused work only",
    body: "We don't pad engagements with deliverables that don't move numbers. No weekly decks, no strategy documents decoupled from execution, no ancillary services to justify a higher retainer. You're paying for media buying and funnel performance. That's where our attention stays.",
  },
  {
    label: "Full transparency on what's running",
    body: "You have live access to the ad accounts. Weekly reporting covers what we spent, what's performing, what we're changing, and why. No vanity dashboards. No metrics we're hiding behind. If something isn't working, you'll know before we tell you. Because you can see it.",
  },
];

function DiffItem({ item, index }) {
  const [ref, vis] = useScrollReveal(0.1);
  return (
    <div
      ref={ref}
      data-testid={`differentiator-${index + 1}`}
      className={`group grid md:grid-cols-[0.4fr,1fr] gap-6 md:gap-16 lg:gap-24 py-12 md:py-16 border-b border-[#1E293B] reveal ${vis ? 'visible' : ''}`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="flex items-start gap-5">
        <span className="font-['Playfair_Display'] font-semibold text-[48px] md:text-[56px] leading-none text-[#0064E0] opacity-30 select-none">
          {String(index + 1).padStart(2, '0')}
        </span>
      </div>
      <div>
        <h3 className="font-['Playfair_Display'] font-semibold text-[24px] md:text-[28px] lg:text-[32px] text-white leading-[1.15] tracking-[-0.01em]">
          {item.label}
        </h3>
        <p className="mt-4 text-[16px] md:text-[17px] leading-[1.7] text-[#94A3B8]">
          {item.body}
        </p>
      </div>
    </div>
  );
}

export const WhyDifferent = () => {
  const [headerRef, headerVis] = useScrollReveal();

  return (
    <section
      id="why-different"
      data-testid="why-different-section"
      className="bg-[#0F172A] py-28 md:py-40 lg:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div ref={headerRef} className={`reveal ${headerVis ? 'visible' : ''}`}>
          <div className="w-12 h-[3px] bg-[#0064E0] rounded mb-6" />
          <h2
            data-testid="why-different-heading"
            className="font-['Playfair_Display'] font-semibold text-[clamp(36px,5vw,68px)] tracking-[-0.03em] text-white leading-[1.0] max-w-[800px]"
          >
            What changes when you remove the agency overhead
          </h2>
        </div>

        {/* Items */}
        <div className="mt-16 md:mt-24">
          {items.map((item, i) => (
            <DiffItem key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
